import DocumentEditor from './components/FacebookAdEditor';
import DocumentPreview from './components/FacebookAdPreview';
import {
  getPdfContent, getCsvContent, getTxtContent, getClipboardItem,
} from './FacebookAd.getContent';
import Icon from './FacebookAd.icon';

// maximum primary text characters for facebook image ads
const MAX_FACEBOOK_PRIMARYTEXT_CHARS = 125;
const MAX_FACEBOOK_HEADLINES_CHARS = 70;

export default {
  getPdfContent,
  getCsvContent,
  getTxtContent,
  getClipboardItem,
  Icon,
  DocumentEditor,
  DocumentPreview,
  stringifyContent: (templateContent) => {
    if (typeof templateContent === 'string') {
      return templateContent;
    }

    return templateContent.join(',');
  },
  getWordCounts: (document) => {
    const newContent = Array.isArray(document.content) ? document.content : [document.content, '', ''];
    const { 0: headline, 1: linkDescription, 2: mainContent } = newContent;

    return [{
      title: 'Primary',
      value: mainContent,
      limit: MAX_FACEBOOK_PRIMARYTEXT_CHARS,
    }, {
      title: 'Headline',
      value: `${headline} ${linkDescription}`,
      limit: MAX_FACEBOOK_HEADLINES_CHARS,
    },
    ];
  },
  onMoreLikeThis: async (props, document) => {
    if (!props.canManageDocuments) {
      return null;
    }

    return props.generate({ likeId: document._id });
  },
};
